export var EVENTS;
(function (EVENTS) {
    EVENTS[EVENTS["ROUTE_MATCHED"] = "route-matched"] = "ROUTE_MATCHED";
    EVENTS[EVENTS["ROUTE_NOT_MATCHED"] = "route-not-matched"] = "ROUTE_NOT_MATCHED";
})(EVENTS || (EVENTS = {}));
